import styled from "styled-components";
import { SeparatorDefaultBox } from "./separator.default.box";

export const SeparatorMrGreenBox = styled(SeparatorDefaultBox)`
    background: ${props => props.theme.colors.brandSecondaryLight};
    width: 1px;
`;
